export const GTM_LIST_LABEL = 'virtual_package';
